import { useTranslation } from "react-i18next";

export function ApplePayTabInfo({showMessage, isFormSubmitted}) {

  const { t } = useTranslation("common");

  return (
    <>
      {(showMessage && isFormSubmitted) ? <p>{t('proceeding-payment')}</p> : <p>{t('pay-with-apple-pay')}</p>}
    </>
  );
}
